var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"112 184 256 328 400 184","style":{"fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48px"}}));
}

ChevronDown.defaultProps = {"width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
